import { render } from "./prime.vue?vue&type=template&id=7921fae0&scoped=true"
import script from "./prime.vue?vue&type=script&lang=js"
export * from "./prime.vue?vue&type=script&lang=js"

import "./prime.vue?vue&type=style&index=0&id=7921fae0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7921fae0"]])

export default __exports__